import { render, staticRenderFns } from "./private-fl223-proposal-card.vue?vue&type=template&id=767d231e&scoped=true&"
import script from "./private-fl223-proposal-card.vue?vue&type=script&lang=js&"
export * from "./private-fl223-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./private-fl223-proposal-card.vue?vue&type=style&index=0&id=767d231e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d231e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767d231e')) {
      api.createRecord('767d231e', component.options)
    } else {
      api.reload('767d231e', component.options)
    }
    module.hot.accept("./private-fl223-proposal-card.vue?vue&type=template&id=767d231e&scoped=true&", function () {
      api.rerender('767d231e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/private-fl223-proposal-card.vue"
export default component.exports